import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { lazy, Suspense } from "react";
import Header from "./components/Header";
import Footer from "./components/Footer";
import ScrollToTop from "./components/ScrollToTop";

// Route-based code splitting - only load page code when navigated to
const HomePage = lazy(() => import("./pages/HomePage"));
const AboutPage = lazy(() => import("./pages/AboutPage"));
const ServicesPage = lazy(() => import("./pages/ServicesPage"));
const PortfolioPage = lazy(() => import("./pages/PortfolioPage"));
const LearnMorePage = lazy(() => import("./pages/LearnMorePage"));
const ContactPage = lazy(() => import("./pages/ContactPage"));
const ReviewsPreviewPage = lazy(() => import("./pages/ReviewsPreviewPage"));
const DeckQuotePage = lazy(() => import("./pages/DeckQuotePage"));
const FenceQuotePage = lazy(() => import("./pages/FenceQuotePage"));
const ServiceAreasPage = lazy(() => import("./pages/ServiceAreasPage"));
const WarrantyClaimPage = lazy(() => import("./pages/WarrantyClaimPage"));
const WarrantyPage = lazy(() => import("./pages/WarrantyPage"));

// Minimal loading fallback
const PageLoader = () => (
  <div className="min-h-screen flex items-center justify-center bg-[#F5F0EB]">
    <div className="w-8 h-8 border-3 border-[#1A283D] border-t-transparent rounded-full animate-spin" />
  </div>
);

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <ScrollToTop />
        <Header />
        <Suspense fallback={<PageLoader />}>
          <main>
            <Routes>
              <Route path="/" element={<HomePage />} />
              <Route path="/home" element={<HomePage />} />
              <Route path="/about" element={<AboutPage />} />
              <Route path="/services" element={<ServicesPage />} />
              <Route path="/portfolio" element={<PortfolioPage />} />
              <Route path="/learn-more" element={<LearnMorePage />} />
              <Route path="/contact" element={<ContactPage />} />
              <Route path="/deck-quote" element={<DeckQuotePage />} />
              <Route path="/fence-quote" element={<FenceQuotePage />} />
              <Route path="/reviews-preview" element={<ReviewsPreviewPage />} />
              <Route path="/service-areas" element={<ServiceAreasPage />} />
              <Route path="/warranty" element={<WarrantyPage />} />
              <Route path="/warranty-claim" element={<WarrantyClaimPage />} />
            </Routes>
          </main>
        </Suspense>
        <Footer />
      </BrowserRouter>
    </div>
  );
}

export default App;
